import { sceneImages } from './images';

export const mountSteps = [
  {
    id: 'mount',
    title: 'Install once.',
    body: 'Position and install the magnetic mounting base at the lighting location you want. That spot is now permanent.',
  },
  {
    id: 'remove',
    title: 'Remove the light.',
    body: 'When charging is needed, lift the M1 PRO off. The mounting base stays fixed in its original position.',
  },
  {
    id: 'reattach',
    title: 'Reattach or swap.',
    body: 'Attach the charged M1 PRO — or a charged backup unit — magnetically to the same mounting position.',
  },
];

/** Comparison rows: removable setup vs. Magnetic Mount System. */
export const mountComparison = [
  { label: 'After charging', other: 'Find the spot and reposition the light', ours: 'Snaps back onto the same base' },
  { label: 'Measuring', other: 'Re-measure to match the layout', ours: 'Never — the position is fixed' },
  { label: 'Mounting hardware', other: 'Removed and reinstalled each time', ours: 'Installed once, stays put' },
  { label: 'Lighting layout', other: 'Drifts a little with every recharge', ours: 'Identical night after night' },
];

export const rotationSteps = [
  'Keep one set installed on your fixed magnetic bases.',
  'Keep a second set charged and ready on the side.',
  'When the installed lights need charging, lift them off and snap the charged set onto the same bases.',
  'Recharge the removed set — ready for the next exchange.',
];

export const mountApplications = [
  {
    title: 'Pools',
    body: 'Fixed positions along the walls keep every swap in the same layout.',
    image: sceneImages.mediumPool,
  },
  {
    title: 'Spas',
    body: 'One base per seat line. Lift, recharge and return — the glow never shifts.',
    image: sceneImages.spa,
  },
  {
    title: 'Stairs',
    body: 'Each step keeps its own base, so the entry lights up the same way every night.',
    image: sceneImages.poolSteps,
  },
  {
    title: 'Docks / Marinas',
    body: 'An organized run of positions along the dock that stays aligned after every recharge.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/5d646ac6-7449-4a34-bdf4-211e0e266baa.jpg',
  },
];
